import { render, staticRenderFns } from "./CustomerReportChart.vue?vue&type=template&id=181de550"
import script from "./CustomerReportChart.vue?vue&type=script&lang=js"
export * from "./CustomerReportChart.vue?vue&type=script&lang=js"
import style0 from "./CustomerReportChart.vue?vue&type=style&index=0&id=181de550&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports